import { Modal, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { Input } from "./Input";
import { Button } from "./Button";
import { Vehicle } from "../Data/ApiTypes";
import { colors } from "../Data/FakeData";
import { getStateEnumFromCode } from "../Data/UsState";
import { useEffect } from "react";

export interface AddVehicleModalProps {
    show:     boolean;
    setShow:  ( b: boolean ) => void;
    onSubmit: ( v: Vehicle ) => void;
    vehicleToEdit?: Vehicle; 
}

export function AddVehicleModal( props: AddVehicleModalProps ) {
    const { show, setShow, onSubmit, vehicleToEdit } = { ...props };
    const { handleSubmit, register, getValues, reset, control, formState: { errors } }
        = useForm<Vehicle>( { defaultValues: { licensePlateNumber: "", stateCode: "" } } );

    useEffect(() => {
    if (vehicleToEdit) {
        reset(vehicleToEdit);
    } else {
        reset({ make: "", model: "", licensePlateNumber: "", stateCode: "", color: undefined });
    }
    }, [vehicleToEdit, reset]);


    function submit() {
        const vals = getValues();
        onSubmit( vals );
        reset( { make: "", model: "", licensePlateNumber: "", stateCode: "", color: undefined } );
        setShow( false );
    }

    return <Modal show={props.show} centered>
            <Modal.Header className="h4">
                {vehicleToEdit ? "Edit Vehicle" : "Add Vehicle"}
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit( submit )}>
                    <div className="d-flex flex-row w-100 gap-3 mb-3">
                        <Input className="w-100"
                            type="text"
                            label="Make"
                            formNoValidate
                            {...register( "make", { required: "Make is required" } )}
                            error={errors.make} />
                        <Input className="w-100"
                            type="text"
                            label="Model"
                            formNoValidate
                            {...register( "model", { required: "Model is required" } )}
                            error={errors.model} />
                    </div>
                    <div>
                        <Input
                            type="text"
                            label="2-Letter State Code"
                            formNoValidate
                            {...register( "stateCode", {
                                required: "2-Letter State Code is required",
                                validate: ( value ) => {
                                    if( !value )
                                        return true;
                                    const stateEnum = getStateEnumFromCode( value );
                                    return stateEnum !== undefined || "Invalid state code";
                                },
                            } )}
                            error={errors.stateCode}
                            maxLength={2} />
                    </div>
                    <div>
                        <Input
                            type="text"
                            label="License Plate Number"
                            formNoValidate
                            {...register( "licensePlateNumber", { required: "License Plate Number is required" } )}
                            maxLength={10}
                            error={errors.licensePlateNumber} />
                    </div>
                    <div className="mb-3">
                        Vehicle Color
                    <Controller
                    control={control}
                    name="color"
                    rules={{ required: "Vehicle Color is required" }}
                    render={({ field: { onChange, onBlur, value, ref } }) => {
                        return (
                        <div
                            className="mb-2"
                            style={{
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "repeat(6, 1fr)",
                            justifyItems: "center",
                            gap: "0.20em",
                            }}
                        >
                            {colors.map((col, index) => {
                            const sel = value === col ? "border border-primary-subtle border-4 shadow" : "";
                            return (
                                <div
                                key={`${col}-${index}`}
                                className={`${sel} m-1 border d-inline-block`}
                                style={{ height: 48, width: 48, backgroundColor: col }}
                                onClick={() => onChange(col)}
                                />
                            );
                            })}
                            {errors.color && (
                            <Form.Text className="d-block text-danger">{errors.color.message}</Form.Text>
                            )}
                        </div>
                        );
                    }}
                    />
                    </div>
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" className="w-100" onClick={() => {setShow( false ); reset(); }}>
                            Cancel
                        </Button>
                        <Button type="submit" className="w-100 btn-main">
                            {vehicleToEdit ? "Save Changes" : "Add Vehicle"}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
}